"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePmMarginsForMoves = exports.calculateLinearFuturePnl = exports.calculatePnl = exports.createEmptyTotalRow = exports.getWorstPMColumn = exports.getPositionsCalculations = void 0;
const calculationsCore_1 = require("../calculationsCore");
const types_1 = require("../types");
// The correct way to do this is by multiplying with index, however since on the platform we multiply by markPrice we will introduce that here as well
const getUsdPriceMultiplier = (ticker) => {
    return (0, calculationsCore_1.getInstrumentType)(ticker.instrument) === types_1.PositionType.Future
        ? ticker.markPrice
        : ticker.underlyingPrice;
};
const getPositionsCalculations = (pageOperationCurrency, timestamp, positions, tickers, indices) => {
    let positionsCalculations = {};
    const ivMoves = (0, calculationsCore_1.getIVMoves)(pageOperationCurrency);
    // const checkedPositions = positions.filter((p) => p.checked);
    // const contingencies = calculateContingencies(checkedPositions, tickers);
    // const pmMarginTotalRow = createEmptyTotalRow(ivMoves.length);
    for (const position of positions) {
        const positionType = (0, calculationsCore_1.getInstrumentType)(position.instrument);
        const indexPrice = indices[(0, calculationsCore_1.getBaseCurrencyFromInstrumentString)(position.instrument)];
        const ticker = tickers[position.instrument];
        const usdPriceMultiplier = getUsdPriceMultiplier(ticker);
        const isLinear = (0, calculationsCore_1.isLinearPerpetual)(position.instrument);
        positionsCalculations[position.uuid] = {
            contingency: 0,
            position,
            pmMargins: { im: 0, imUsd: 0, mm: 0, mmUsd: 0 },
            pmMarginsForMoves: [],
            smMargins: { im: 0, imUsd: 0, mm: 0, mmUsd: 0 },
            pnl: 0,
            pnlUsd: 0,
            contingencyUsd: 0,
            greeks: {
                gamma: 0,
                vega: 0,
                theta: 0,
                delta: 0,
                rho: 0,
                netDelta: 0,
            },
            roi: 0,
        };
        // PM margins
        const pmMarginsForMoves = isLinear
            ? (0, exports.createEmptyTotalRow)(ivMoves.length)
            : (0, exports.calculatePmMarginsForMoves)(position, ivMoves, ticker);
        positionsCalculations[position.uuid].pmMarginsForMoves = pmMarginsForMoves;
        // // contingency
        // const contingency = Math.abs(contingencies[position.uuid]);
        const contingency = 0;
        positionsCalculations[position.uuid].contingency = isNaN(contingency)
            ? 0
            : contingency;
        positionsCalculations[position.uuid].contingencyUsd =
            positionsCalculations[position.uuid].contingency * usdPriceMultiplier;
        // // SM margins
        const smMargins = (0, calculationsCore_1.calculatePositionSmMargin)(position, indexPrice, tickers[position.instrument]);
        positionsCalculations[position.uuid].smMargins = Object.assign(Object.assign({}, smMargins), { imUsd: isLinear ? smMargins.im : smMargins.im * usdPriceMultiplier, mmUsd: isLinear ? smMargins.mm : smMargins.mm * usdPriceMultiplier });
        const pnl = isLinear
            ? (0, exports.calculateLinearFuturePnl)(position, ticker.markPrice, types_1.CurrencyType.FIAT)
            : (0, exports.calculatePnl)(position, ticker, types_1.CurrencyType.CRYPTO);
        positionsCalculations[position.uuid].pnl = pnl;
        positionsCalculations[position.uuid].pnlUsd = isLinear
            ? pnl
            : pnl * usdPriceMultiplier;
        const isNotionalGamma = pageOperationCurrency === types_1.Currency.ALL ||
            pageOperationCurrency === types_1.Currency.USDC;
        const greeks = isLinear
            ? {
                gamma: 0,
                vega: 0,
                theta: 0,
                rho: 0,
                delta: position.amount,
                netDelta: position.amount * ticker.markPrice,
            }
            : (0, calculationsCore_1.getGreeks)(position.amount, positionType, isNotionalGamma, position.instrument, ticker, timestamp, new Date().getTime());
        positionsCalculations[position.uuid].greeks = greeks;
        const roi = positionType === types_1.PositionType.Future
            ? (pnl / smMargins.im) * 100
            : ((ticker.markPrice - position.averagePrice) / position.averagePrice) *
                100;
        positionsCalculations[position.uuid].roi = roi;
        // Summing total row
        // for (let i = 0; i < ivMoves.length; i++) {
        //   for (let volChangeIndex = 0; volChangeIndex < 3; volChangeIndex++) {
        //     if (position.checked) {
        //       pmMarginTotalRow[i][volChangeIndex] +=
        //         pmMarginsForMoves[i][volChangeIndex];
        //     }
        //   }
        // }
    }
    // const { worstColumn, min, max } = getWorstPMColumn(pmMarginTotalRow);
    // for (const position of positions) {
    //   const usdPriceMultiplier = getUsdPriceMultiplier(
    //     tickers[position.instrument]
    //   );
    //   if (position.checked) {
    //     const mm =
    //       positionsCalculations[position.uuid].pmMarginsForMoves[
    //         worstColumn.moveIndex
    //       ][worstColumn.volChangeIndex] +
    //       positionsCalculations[position.uuid].contingency;
    //     const { initialMarginFactor } =
    //       paramsMap[getInstrumentCurrency(position.instrument)];
    //     const im = initialMarginFactor * mm;
    //     positionsCalculations[position.uuid].pmMargins = {
    //       im,
    //       imUsd: im * usdPriceMultiplier,
    //       mm,
    //       mmUsd: mm * usdPriceMultiplier,
    //     };
    //   } else {
    //     positionsCalculations[position.uuid].pmMargins = {
    //       im: 0,
    //       imUsd: 0,
    //       mm: 0,
    //       mmUsd: 0,
    //     };
    //   }
    // }
    return {
        positionsCalculations,
        worstColumn: { moveIndex: 0, volChangeIndex: 0 },
        range: { min: 0, max: 0 },
    };
};
exports.getPositionsCalculations = getPositionsCalculations;
const getWorstPMColumn = (pmMarginTotalRow) => {
    let worstColumnIdentifier = {
        moveIndex: 0,
        volChangeIndex: 0,
    };
    let max = Number.MIN_SAFE_INTEGER;
    let min = Number.MAX_SAFE_INTEGER;
    for (let moveIndex = 0; moveIndex < pmMarginTotalRow.length; moveIndex++) {
        for (let volChangeIndex = 0; volChangeIndex < 3; volChangeIndex++) {
            max = Math.max(max, pmMarginTotalRow[moveIndex][volChangeIndex]);
            if (pmMarginTotalRow[moveIndex][volChangeIndex] < min) {
                min = pmMarginTotalRow[moveIndex][volChangeIndex];
                worstColumnIdentifier = {
                    moveIndex,
                    volChangeIndex,
                };
            }
        }
    }
    return { worstColumn: worstColumnIdentifier, min, max };
};
exports.getWorstPMColumn = getWorstPMColumn;
const createEmptyTotalRow = (moves) => {
    let res = [];
    for (let i = 0; i < moves; i++) {
        res.push([]);
        for (let j = 0; j < 3; j++) {
            res[i].push(0);
        }
    }
    return res;
};
exports.createEmptyTotalRow = createEmptyTotalRow;
const calculatePnl = (position, ticker, currencyType) => {
    const positionType = (0, calculationsCore_1.getInstrumentType)(position.instrument);
    return positionType === types_1.PositionType.Future
        ? (0, calculationsCore_1.calculateFuturePnl)(currencyType, position.amount, position.averagePrice, ticker.markPrice)
        : (0, calculationsCore_1.calculateOptionPnl)(currencyType, position.amount, position.averagePrice, ticker.underlyingPrice, ticker.markPrice);
};
exports.calculatePnl = calculatePnl;
const calculateLinearFuturePnl = (position, index, currencyType) => {
    return (0, calculationsCore_1.calculateLinearFuturePoint)(currencyType, position.averagePrice, index, position.amount).expirePt;
};
exports.calculateLinearFuturePnl = calculateLinearFuturePnl;
const calculatePmMarginsForMoves = (position, ivMoves, ticker) => {
    const positionType = (0, calculationsCore_1.getInstrumentType)(position.instrument);
    return positionType === types_1.PositionType.Option
        ? (0, calculationsCore_1.calculateOptionRiskValues)(position, ivMoves, ticker)
        : (0, calculationsCore_1.calculateFutureRiskValues)(position.amount, ivMoves, ticker.markPrice);
};
exports.calculatePmMarginsForMoves = calculatePmMarginsForMoves;
